import { gql } from '@apollo/client';
import ORGANIZATION_ASSOCIATION_LICENSE_USAGE_FRAGMENT from 'graph/fragments/organization-association-license-usage';
import BASE_ORGANIZATION_ROLE_FRAGMENT from 'graph/fragments/organization-role';
import BASE_USER_FRAGMENT from 'graph/fragments/user';

export default gql`
  mutation updateUser($where: UserWhereInput!, $data: UserUpdateInput!) {
    updateUser(data: $data, where: $where) {
      ...BaseUser
      licenseUsage {
        product {
          id
          name
          iconUrl
        }
      }
      organizationAssociations {
        organizationId
        ...BaseOrganizationAssociationLicenseUsage
        organizationRoles {
          ...BaseOrganizationRole
        }
      }
    }
  }
  ${BASE_ORGANIZATION_ROLE_FRAGMENT}
  ${BASE_USER_FRAGMENT}
  ${ORGANIZATION_ASSOCIATION_LICENSE_USAGE_FRAGMENT}
`;
